<div #dashboardGrid
     class="grid grid-cols-2 grid-rows-2 main-2xl:grid-cols-3 break-all w-full h-full overflow-hidden p-6 gap-6">
  <!-- Zwei gleich hohe Zeilen, die Seite selbst scrollt nicht – die Kacheln scrollen innen.
       Unterhalb von 2xl: 2 Spalten, unten eine kombinierte Prüfungs-Kachel (2x2 Kacheln).
       Ab 2xl: 3 Spalten, unten Kennzahlen (1 Spalte) und Prüflaufliste (2 Spalten). -->
  <!-- top row -->
  <!-- Projektinformationen -->
  <app-dashboard-card #projectCard (headerClick)="navigateToProjectSettings()"
                      [tooltipText]="'Übersicht und Verwaltung aller Projektdaten und Beteiligten.'"
                      class="border border-gray-200 w-full h-full rounded-lg p-3 row-span-1">
    <div card-icon>
      <fa-icon [icon]="faBuilding" class="text-base"></fa-icon>
    </div>
    <span card-title class="line-clamp-1">Projektinformationen</span>
    <div card-content class="flex w-full h-full overflow-hidden">
      <app-dashboard-project-information [project]="project"
                                         class="flex w-full h-full overflow-hidden"></app-dashboard-project-information>
    </div>
  </app-dashboard-card>

  <!-- Dateien -->
  <app-dashboard-card #filesCard (headerClick)="navigateToFiles()"
                      [tooltipText]="'Übersicht aller Projektdateien und Speicherverbrauch.'"
                      class="border border-gray-200 w-full h-full rounded-lg p-3 row-span-1">
    <div card-icon>
      <fa-icon [icon]="faFolderOpen" class="text-base"></fa-icon>
    </div>
    <span card-title class="line-clamp-1">Dateien</span>
    <div card-content class="flex w-full h-full overflow-hidden">
      <app-dashboard-files [fileSummary]="fileSummary"
                           [loading]="!filesLoaded"
                           class="flex w-full overflow-hidden"></app-dashboard-files>
    </div>
  </app-dashboard-card>

  <!-- Tasks -->
  <app-dashboard-card #tasksCard (headerClick)="navigateToTaskBoard()"
                      [tooltipText]="'Planung und Verwaltung von Tasks/BCF.'"
                      class="border border-gray-200 w-full h-full rounded-lg p-3 row-span-1">
    <div card-icon>
      <fa-icon [icon]="faClipboardCheck" class="text-base"></fa-icon>
    </div>
    <span card-title class="line-clamp-1">Tasks</span>
    <div card-content class="flex w-full h-full overflow-hidden">
      <app-dashboard-tasks [allTasks]="allTasksList"
                           [basicTasks]="basicTasks"
                           [loading]="!tasksLoaded"
                           class="flex w-full overflow-hidden"></app-dashboard-tasks>
    </div>
  </app-dashboard-card>

  <!-- bottom row -->
  @if (threeColumnLayout) {
    <!-- Kennzahlen als eigene Kachel -->
    <app-dashboard-card (headerClick)="navigateToReports()"
                        [tooltipText]="'Kennzahlen der ausgeführten Prüfläufe der letzten 30 Tage.'"
                        class="border border-gray-200 w-full h-full rounded-lg p-3 row-span-1">
      <div card-icon>
        <fa-icon [icon]="faFileCircleCheck" class="text-base"></fa-icon>
      </div>
      <span card-title class="line-clamp-1">Übersicht Prüfungen</span>
      <div card-content class="flex w-full h-full overflow-hidden">
        <app-dashboard-check-metrics [checks]="checkRuns"
                                     [loading]="!checkRunsLoaded"
                                     class="flex w-full h-full overflow-hidden"
                                     variant="fill"></app-dashboard-check-metrics>
      </div>
    </app-dashboard-card>

    <!-- Prüflaufliste über zwei Spalten; die Überschrift steht im Kachelkopf -->
    <app-dashboard-card (headerClick)="navigateToReports()"
                        [tooltipText]="'Zuletzt ausgeführte Prüfläufe mit Prüftyp, Prüfer*in und Status.'"
                        class="border border-gray-200 w-full h-full rounded-lg p-3 row-span-1 main-2xl:col-span-2">
      <div card-icon>
        <fa-icon [icon]="faClipboardList" class="text-base"></fa-icon>
      </div>
      <span card-title class="line-clamp-1">Letzte Prüfungen</span>
      <div card-content class="flex w-full h-full overflow-hidden">
        <app-dashboard-check-list (checkClick)="openCheckRun($event)"
                                  (createCheck)="navigateToCatalog()"
                                  [checks]="checkRuns"
                                  [loading]="!checkRunsLoaded"
                                  [showHeading]="false"
                                  class="flex w-full overflow-hidden"></app-dashboard-check-list>
      </div>
    </app-dashboard-card>
  } @else {
    <!-- Kombinierte Kachel: Kennzahlen kompakt oben, Prüfläufe darunter -->
    <app-dashboard-card (headerClick)="navigateToReports()"
                        [tooltipText]="'Kennzahlen und zuletzt ausgeführte Prüfläufe.'"
                        class="border border-gray-200 w-full h-full rounded-lg p-3 row-span-1">
      <div card-icon>
        <fa-icon [icon]="faFileCircleCheck" class="text-base"></fa-icon>
      </div>
      <span card-title class="line-clamp-1">Übersicht Prüfungen</span>
      <div card-content class="flex flex-col w-full h-full gap-6 overflow-hidden">
        <app-dashboard-check-metrics [checks]="checkRuns"
                                     [loading]="!checkRunsLoaded"
                                     class="w-full shrink-0"
                                     variant="compact"></app-dashboard-check-metrics>
        <app-dashboard-check-list (checkClick)="openCheckRun($event)"
                                  (createCheck)="navigateToCatalog()"
                                  [checks]="checkRuns"
                                  [loading]="!checkRunsLoaded"
                                  class="flex flex-1 min-h-0 w-full overflow-hidden"></app-dashboard-check-list>
      </div>
    </app-dashboard-card>
  }
</div>
